import { render, staticRenderFns } from "./Insight.vue?vue&type=template&id=105e1e4c&scoped=true"
import script from "./Insight.vue?vue&type=script&lang=js"
export * from "./Insight.vue?vue&type=script&lang=js"
import style0 from "./Insight.vue?vue&type=style&index=0&id=105e1e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e1e4c",
  null
  
)

export default component.exports